import { JSX } from 'react';
import petardIcon from 'assets/icons/petard-icon.svg';
import { isMappedGroupSchedule } from 'entities/index';
import { IMappedTeacherSchedule } from 'entities/types';
import { IMappedGroupSchedule } from 'entities/types';
import {
  CardLineGroupSchedule,
  СardLineTeacherSchedule,
} from 'widgets/schedule/stageTimelineSchedule/cardLineSchedule';

export const makeLesson = (
  data: IMappedGroupSchedule[] | IMappedTeacherSchedule[],
) => {
  const cards: JSX.Element[] = [];

  data.forEach((item) => {
    if (isMappedGroupSchedule(item)) {
      cards.push(
        <CardLineGroupSchedule
          data={item as IMappedGroupSchedule}
          key={item.key}
        />,
      );
    } else {
      cards.push(
        <СardLineTeacherSchedule
          data={item as IMappedTeacherSchedule}
          key={item.key}
        />,
      );
    }
  });

  if (!data.length) {
    cards.push(
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '760px',
          height: '100%',
          marginLeft: '130px',
          fontSize: '15px',
        }}
        key={0}
      >
        <div style={{ marginRight: '8px', textAlign: 'center' }}>
          Занятий нет
        </div>
        <img src={petardIcon} alt="Хлопушка" />
      </div>,
    );
  }
  return cards;
};
